import Plyr from 'plyr';

const plyrInstances = new Map();

const handlePlyrBlockClick = (event) => {
	const videoBlock = event.target.closest('.video-block.plyr-managed:not(.video-link):not(.marketing-list-access)');

	if (!videoBlock) {
		return;
	}

	event.preventDefault();

	const plyrEl = videoBlock.querySelector('.plyr-video');
	if (!plyrEl) {
		return;
	}

	// Hide the thumbnail overlay
	const info = videoBlock.querySelector('.video-info');
	const display = videoBlock.querySelector('.video-display');

	if (info) {
		info.classList.add('hidden');
	}

	if (display) {
		display.classList.remove('hidden');
	}

	// If already initialised, just play
	if (plyrInstances.has(plyrEl)) {
		plyrInstances.get(plyrEl).play();
		return;
	}

	// Initialise Plyr and autoplay
	const player = new Plyr(plyrEl, {
		controls: [
			'play-large',
			'play',
			'progress',
			'current-time',
			'mute',
			'volume',
			'captions',
			'fullscreen',
		],
		captions: {
			active: true,
			language: 'auto',
			update: true,
		},
		youtube: {
			cc_load_policy: 1,
		},
		// Start muted so the browser's autoplay policy always permits playback
		// (unmuted autoplay is blocked on low-engagement Chrome/Edge profiles,
		// which caused playback to pause ~2s in). We unmute on `ready` below —
		// that runs off the user's click, so the unmute counts as gesture-driven.
		autoplay: true,
		muted: true,
	});

	plyrInstances.set(plyrEl, player);

	player.on('ready', () => {
		player.play();

		// Now that playback has been allowed (muted), restore sound. This is a
		// direct consequence of the user's click, so the browser treats it as a
		// user gesture and does not re-block the video.
		player.muted = false;
		player.volume = 1;

		// Plyr's CC button is hidden via `.plyr [data-plyr='captions'] { display: none }` and
		// only shown when Plyr adds `.plyr--captions-enabled` to the container — which it only
		// does when it detects <track> elements. YouTube iframes have none, so we add the class
		// manually and wire the button directly to YouTube's native caption API instead.
		if (player.provider === 'youtube') {
			player.elements.container.classList.add('plyr--captions-enabled');

			const captionsBtn = player.elements.container.querySelector('[data-plyr="captions"]');
			if (captionsBtn) {
				let captionsActive = true;

				// Set initial state to pressed: cc_load_policy: 1 starts with captions on
				captionsBtn.classList.add('plyr__control--pressed');
				captionsBtn.setAttribute('aria-pressed', 'true');

				captionsBtn.addEventListener('click', (e) => {
					// Stop the event bubbling to Plyr's delegated handler on the controls
					// container — it has no YouTube caption API support and would conflict
					e.stopPropagation();

					captionsActive = !captionsActive;

					try {
						if (captionsActive) {
							player.embed.loadModule('captions');
						} else {
							player.embed.unloadModule('captions');
						}
					} catch (err) {
						// Video may not have captions available
					}

					captionsBtn.classList.toggle('plyr__control--pressed', captionsActive);
					captionsBtn.setAttribute('aria-pressed', String(captionsActive));
				});
			}
		}
	});
};

if (document.querySelector('.video-block.plyr-managed')) {
	document.addEventListener('click', handlePlyrBlockClick, false);
}
